import { mdiBookOpenPageVariantOutline } from '@mdi/js'

export default {
  title: 'Book',
  to: 'book-school',
  icon: mdiBookOpenPageVariantOutline,
  resource: 'BookSchool',
  action: 'read',
}
